<template>
  <div>
    <label>{{ label }}</label>
    <ul ref="dropdown" :id="id" :class="[
          'nt-select2', { 'nt-select2--opened': opened }, { 'nt-select2--rounded': rounded }, getTheme
        ]"
      >
      <!-- Button -->
      <li>
        <button :id="id + '-arrow'" class="nt-select2__label" :class="{ 'inactive' :  value.Value == null, 'error' :  error }"
          @click.prevent="changeVisibility"
          @blur="onMouseOut">
            {{ value.Text }}
            <span class="arrow">
              <svg><use xlink:href="#icon-arrow-down"/></svg>
            </span>
        </button>
        <ul ref="content" class="nt-select2__content" :class="contentClass">
          <li :id="id + '-item-' + i" :class="{'active': selected && selected.Value === item.Value }"
              v-for="(item, i) in data" :key="item.id"
            >
              <button v-if="selected && selected.Value" :class="{ 'inactive' :  item.Value == null }" @mousedown.prevent="onClickDropItem(item)">{{ item.Text }}</button>
              <button v-else-if="i > 0" :class="{ 'inactive' :  item.Value == null }" @mousedown.prevent="onClickDropItem(item)">{{ item.Text }}</button>
          </li>
        </ul>
      </li>
    </ul>
    <div class="nt-form-error" v-if="error">{{ error }}</div>
    <div class="nt-form-text-helper" v-if="helperText">{{ helperText }}</div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'nt-select2',
  props: {
    id: {
      type: String,
      default: 'select'
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    dataSource: {
      type: Array,
      default: []
    },
    valueSelected: {
      type: String,
      default: null
    },
    validators: {
      type: Array,
      default: []
    },
    rounded: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'default'
    },
    helperText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: [],
      default: {
        Text: this.$props.placeholder,
        Value: null
      },
      opened: false,
      selected: null,
      error: null,
      contentPosition: 'bottom'
    }
  },
  watch: {
    '$parent.errors': function (values) {
      this.error = _.values(_.find(values, this.id, _.first))[0]
    }
  },
  computed: {
    getTheme() {
      return `nt-select2--${this.theme}`
    },
    contentClass() {
      return `nt-select2__content--${this.contentPosition}`
    },
    value() {
      return this.selected ? this.selected : this.default
    }
  },
  created() {
    this.data.push(this.default)
    this.data = this.data.concat(this.dataSource)

    this.selected = this.getItemSelected()

    if (this.$parent.$data.formData !== undefined) {
      const { formData, validators } = this.$parent.$data
      // Add to form initial values
      Object.assign(formData, {
        [this.id]: this.selected ? this.selected.Value : null
      })
      // Add validators to form
      Object.assign(validators, {
        [this.id]: this.validators
      })
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.showIn()
    })
  },
  methods: {
    getItemSelected() {
      return this.dataSource.find(item => item.Value.toString() === this.valueSelected)
    },
    changeVisibility() {
      this.opened = !this.opened

      this.$nextTick(() => {
        this.showIn()
      })
    },
    onClickDropItem(item) {
      this.selected = item
      this.changeVisibility()
      this.changeForm()
    },
    onMouseOut() {
      this.opened = false
    },
    changeForm() {
      this.$parent.$emit('changeForm', {
        [this.id]: this.selected ? this.selected.Value : null
      })
    },
    showIn() {
      if (!this.opened) return

      const { dropdown, content } = this.$refs

      const selectBounding = dropdown.getBoundingClientRect()
      const contentLimit = Math.abs(content.clientHeight / 2)

      const top = selectBounding.top
      const bottom = window.innerHeight - selectBounding.bottom

      if (top >= contentLimit && bottom >= contentLimit) {
        content.style.top = `-${contentLimit - (selectBounding.height / 2)}px`
        this.contentPosition = 'center'
      } else if (top >= contentLimit) {
        content.style.top = `-${content.clientHeight}px`
        this.contentPosition = 'top'
      } else {
        content.style.top = null
        this.contentPosition = 'bottom'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .nt-select2 {
    $wrap: &;
    margin: 0;
    position: relative;
    background: white;
    list-style: none;
    padding-inline-start: 0;

    &__label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid rgb(184, 184, 184);
      color: #9ddda9;
    }

    &--rounded {
      background: white;
      border-radius: 35px;
      border: none;

      .nt-select2__label {
        border: none;
      }
    }

    & .inactive {
      font-weight: 300;
      color: rgb(204, 204, 204);
    }

    & .active {
      background: #fafafa;
    }

    & .arrow {
      display: flex;
      width: 14px;
      height: 14px;
      float: right;
      fill: #9ddda9;
      color: #9ddda9;
    }

    button {
      width: 100%;
      height: 100%;
      text-align: left;
      font-size: 1.25rem;
      // min-height: 72px;
      margin: 0;
      padding: 0;
      display: flex;
      padding: 20px;
      border-radius: 2px;

      &:hover {
        cursor: pointer;
      }

      &.error {
        border-color: #bd081a;
      }
    }

    &__content {
      position: absolute;
      width: 100%;
      display: none;
      z-index: 50;
      border-style: solid;
      border-width: 2px;
      border-color: rgb(145, 144, 144);
      list-style: none;
      padding-inline-start: 0;
    }

    &--opened {
      // border-bottom-left-radius: 0px;
      // border-bottom-right-radius: 0px;
      
      #{$wrap}__content {
        // border: none;
        display: block;
        overflow: auto;
        max-height: 290px;
        background-color: #FFF;

        &--bottom {
          border-width: 0 1px 1px;
        }

        & > li {
          background-color: #fafafa;
          &:not(:last-child):not(:first-child) {
            border-bottom: 1px solid rgb(184, 184, 184);
          }
          &:hover {
            background-color: #FFF;
          }
        }
      }
    }

    &--small {
      button {
        padding: 10px;
        font-size: 1rem;
      }
    }
  }
</style>

